// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { ChevronDown, ChevronUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// Rendered as an AntD Collapse `expandIcon`: the panel header is already the
// button, so this is a styled label rather than a nested Button.
const SettingsToggle: React.FC<{ isActive?: boolean }> = ({ isActive }) => {
  const { t } = useTranslation();
  const Chevron = isActive ? ChevronUp : ChevronDown;

  return (
    <span className="settings-toggle">
      {t(isActive ? 'apps.app-modal.hide-settings' : 'apps.app-modal.show-settings')}
      <Chevron size={16} aria-hidden="true" />
    </span>
  );
};

export default SettingsToggle;
